import { getType } from 'typesafe-actions';

import { RootAction } from '../actions/types';
import {
  setMobilePrinterList,
  mobilePrinterListError,
  getMobilePrinterList,
  resetMobilePrinter,
} from '../actions/mobilePrinter.actions';
import { MobilePrinterState } from './types';

const initialState: MobilePrinterState = {
  printerList: {
    printers: [],
    error: null,
    hasFetched: false,
    isLoading: false,
  },
};

export default (state: MobilePrinterState = initialState, action: RootAction): MobilePrinterState => {
  switch (action.type) {
    case getType(getMobilePrinterList): {
      return {
        ...state,
        printerList: {
          ...state.printerList,
          isLoading: true,
          hasFetched: true,
        },
      };
    }
    case getType(setMobilePrinterList): {
      return {
        ...state,
        printerList: {
          ...state.printerList,
          printers: action.payload.printers,
          error: null,
          isLoading: false,
        },
      };
    }
    case getType(mobilePrinterListError): {
      return {
        ...state,
        printerList: {
          ...state.printerList,
          error: action.payload.error,
          printers: [],
          isLoading: false,
        },
      };
    }
    case getType(resetMobilePrinter): {
      return initialState;
    }
    default: {
      return state;
    }
  }
};
